<!-- <app-spinner [show]="showSpinner" [size]="150"> </app-spinner> -->
<div *ngIf="webinarRunDTO">
    <div class="row" *ngIf="webinarRunDTO.status !== 'Completed'">
        <div class="col-12">
            <div *ngIf="webinarRunDTO.status == 'Not Started' || webinarRunDTO.status == 'Started'">
                <app-webinar-countdown
                    [webinarName]="webinarRunDTO.webinarName"
                    [secondsToStart]="webinarRunDTO.secondsToStart"
                    [startAt]="webinarRunDTO.webinarStartDateTime"
                    [serverNow]="webinarRunDTO.currentDateTime"
                    (remainingSecondsChange)="countdownRemaining = $event"></app-webinar-countdown>
            </div>
            <div *ngIf="keepRunPlayer">
                <app-play-video
                    [videoUrl]="runVideoUrl"
                    [shouldPlay]="isVideoPlayingPhase"
                    [isMobileView]="isMobileView"
                    [posterUrl]="webinarRunDTO.itemImageUrl"
                    [fileExtension]="webinarRunDTO.fileExtention"
                    (playbackCaughtUp)="onVideoPlaybackCaughtUp()"></app-play-video>
            </div>
            <div *ngIf="isVideoPlayingPhase && !runVideoUrl">
                <h1 class="webinar-soon-heading">Video not available </h1>
            </div>
        </div>
    </div>
    <div class="row seats-row">
        <div class="col-12 col-lg-8 seats-column">
             <div *ngIf="displaySeats">
                <app-user-seat
                    [seats]="webinarRunDTO.userSeats"
                    [selectedSeat]="winnerSeatNumber"
                    [webinarName]="webinarRunDTO.webinarName"
                    [displaySeatsDelaySeconds]="webinarRunDTO.seatsDisplayDelaySeconds"
                    (introScrollComplete)="onSeatIntroScrollComplete()"></app-user-seat>
            </div>
        </div>
        <div id="resultsSection" class="col-12 col-lg-4 flex results-column" *ngIf="shouldShowResultsPanel()">
            <app-display-results [webinarRun]="webinarRunDTO" [status]="webinarRunDTO.status"
                (congrtsPopup)="OpenCongratsPopup($event)"></app-display-results>
        </div>
    </div>
</div>